import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';
import { useTranslation } from '../i18n/I18nContext.jsx';
import { useLocalizedPath } from '../hooks/useLocalizedPath.js';
import LobsterMascot from './LobsterMascot.jsx';
import MascotMenu from './MascotMenu.jsx';

export default function NavBar() {
  const { user, signOut } = useAuth();
  const { t } = useTranslation();
  const lp = useLocalizedPath();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="app-nav" aria-label={t('nav.ariaLabel')}>
      <div className="app-nav-logo-wrap">
        <button
          className="mascot-menu-btn"
          onClick={() => setMenuOpen(v => !v)}
          aria-expanded={menuOpen}
          aria-haspopup="true"
          aria-label={t('nav.menuAriaLabel')}
        >
          <LobsterMascot size={28} />
          <span className="app-nav-brand">Claw-dius</span>
        </button>
        <MascotMenu open={menuOpen} onClose={() => setMenuOpen(false)} authenticated={true} />
      </div>
      <NavLink to={lp('/dashboard')} className={({ isActive }) => `app-nav-link${isActive ? ' active' : ''}`}>
        {t('nav.dashboard')}
      </NavLink>
      <NavLink to={lp('/connector')} className={({ isActive }) => `app-nav-link${isActive ? ' active' : ''}`}>
        {t('nav.connector')}
      </NavLink>
      {user && (
        <button
          className="btn-secondary app-nav-signout"
          onClick={async () => { await signOut(); navigate(lp('/')); }}
          aria-label={t('nav.signOut')}
        >
          {t('nav.signOut')}
        </button>
      )}
    </nav>
  );
}
